import image1 from '../../assets/programs/grip/image1.webp'
import image2 from '../../assets/programs/grip/image2.webp'
import image3 from '../../assets/programs/grip/image_4.webp'
import image6 from '../../assets/programs/grip/image6.webp'
import image7 from '../../assets/programs/grip/image7.webp'
import image8 from '../../assets/programs/grip/image8.webp'
import image9 from '../../assets/programs/grip/image9.webp'

const grip_data = {
    "title": "GRIP - Grassroot Innovation Program",
    "description": "Through GRIP, students tackle societal challenges by developing innovative solutions for issues identified in rural and semi-urban areas, including their own communities. This initiative fosters a deep connection between education and impactful social change.",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image1,
                            "desc": ""
                        },
                        {
                            "src": image2,
                            "desc": ""
                        },
                        {
                            "src": image6,
                            "desc": ""
                        },
                        {
                            "src": image7,
                            "desc": ""
                        },
                        {
                            "src": image8,
                            "desc": ""
                        },
                        {
                            "src": image9,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default grip_data;